<template>
	<div class="container__crudform">
		<div class="container__crudform__crud">
			<div
				data-testid="crudform-component"
				:class="['container__crudform__panel', { container__crudform__panel__visible: isVisible }]"
			>
				<slot />
				<!--  slot quando único não precisa ser nomeado -->
			</div>
		</div>
		<div
			v-show="backdrop && isVisible"
			data-testid="backdrop"
			class="container__crudform__backdrop__visible"
			@click="changeIsVisible"
		/>
	</div>
</template>

<script setup>
import { toRefs } from 'vue'

const props = defineProps({
	changeIsVisible: Function,
	backdrop: {
		type: Boolean,
		default: false,
	},
	visibleIcon: {
		type: Boolean,
		default: true,
	},
	isVisible: {
		type: Boolean,
		default: true,
	},
	titleForm: String,
})
const { backdrop, isVisible } = toRefs(props)
</script>

<style>
.container__crudform__panel {
	position: fixed;
	background-color: white;
	top: 0;
	right: -105%;
	height: 100vh;
	width: 100vw;
	transition: all 0.2s ease-in-out;
	font-size: 0.75rem;
	overflow-y: auto;
	z-index: 10;
	border-radius: 40px 0 0 0;
}

.container__crudform__panel__visible {
	right: 0;
}

.container__crudform__titleclose {
	display: flex;
	justify-content: space-between;
	align-items: center;
	user-select: none;
}

.container__crudform__titleclose i {
	cursor: pointer;
	padding: 0.5rem 0 0.5rem 1rem;
}

.container__crudform__titleclose__title {
	font-size: 1.5rem;
	font-weight: 700;
}

@media screen and (min-width: 992px) {
	.container__crudform__titleclose__title {
		font-size: 1.1rem;
	}

	.container__crudform__backdrop__visible {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-color: rgba(0, 0, 0, 0.2);
		z-index: 9;
	}
}

@media screen and (min-width: 1200px) {
	.container__crudform__panel__visible {
		width: 23vw;
	}
}
</style>
